import create from 'zustand';

import { tableDisplay } from 'constants/table';

type TableParams = {
  isFetching: boolean
  meta: {
    currentPage?: number
    perPage?: number
    total?: Number
    totalPages?: number
    lastPage?: number
  }
  display: {
    Header: string
    type: string
    accessor: string
    superUserOnly?: boolean
  }[]
  data: any[]
  setTable: (_data: Partial<TableParams>) => void
}

const initialTable = {
  isFetching: false,
  meta: {
    perPage: 10,
    total: 10,
    currentPage: 0,
    totalPages: 10,
    lastPage: 2,
  },
  display: [],
  data: [],
};

type TableStore = {
  setTable: (_key: string, _data: Partial<TableParams>) => void
  tables: { [key:string]: TableParams }
}

const useTableStore = create<TableStore>((set, get) => ({
  tables: {},
  setTable: (key, data) => set((state) => {
    const table = {
      ...initialTable,
      display: tableDisplay[key],
      ...state.tables[key],
      ...data,
      setTable: (tableData: TableParams) => get().setTable(key, tableData),
    };

    return {
      tables: { [key]: table },
    };
  }),
}));

export default useTableStore;
